<template>
  <div class="page-wrapper" v-if="imageLoaded">
    <div class="detail-box" :style="{ color: currentTheme.theme_color }">
      <!-- Theme information -->
      <div class="theme-info">
        <div class="graph">
          <img v-if="currentTheme.view_image" :src="$utils.conversion.toServerUrl(currentTheme.view_image)" alt="" />
        </div>

        <div class="text">
          <div class="title">{{ currentTheme.name }}</div>
          <div class="desc">
            {{ currentTheme.description }}
          </div>
        </div>
      </div>

      <!-- Theme opearation -->
      <div class="theme-operation">
        <!-- Modules -->
        <div class="icon-btn">
          <div class="icon-btn-svg clickable" @click="goTopicList" @keypress.enter="goTopicList">
            <inline-svg
              class="svg-icon"
              :src="$assets.svg['theme-module-btn-2']"
              width="100%"
              height="100%"
              fill="#FFF"
            />
          </div>
          <p>Modules</p>
        </div>

        <!-- Guide -->
        <div :class="{ 'icon-btn': true, disabled: !themeGuides }">
          <div :class="{ 'icon-btn-svg': true, clickable: themeGuides }" @click="openGuide" @keypress.enter="openGuide">
            <inline-svg class="svg-icon" :src="$assets.svg['theme-guide-btn-2']" width="100%" height="100%" />
          </div>
          <p>
            Theme Guide
            <span v-if="!themeGuides" v-html="'<br />Coming Soon'" />
          </p>
        </div>

        <!-- Video -->
        <div class="icon-btn disabled">
          <div class="icon-btn-svg">
            <inline-svg class="svg-icon" :src="$assets.svg['theme-video-btn-2']" width="100%" height="100%" />
          </div>
          <p>Videos<br />Coming Soon</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    listThemeId: { required: true },
  },

  data() {
    return {
      imageLoaded: false,
    };
  },

  created() {
    const image = new Image();
    image.onload = () => {
      this.imageLoaded = true;
    };
    image.src = this.$utils.conversion.toServerUrl(this.currentTheme.view_image);
  },

  methods: {
    goTopicList() {
      this.$router.push({
        name: 'topicList',
        params: { themeId: this.listThemeId },
      });
    },
    openGuide() {
      if (!this.themeGuides) {
        return;
      }

      window.open(this.themeGuides[0].src, '_blank');
    },
  },
  computed: {
    currentTheme() {
      return this.$store.getters.currentTheme;
    },
    themeGuides() {
      return this.$utils.analysis.localizeFiles(this.currentTheme.guides);
    },
  },
};
</script>

<style scoped>
.page-wrapper {
  width: 100%;
  height: 100%;
}
.detail-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  box-sizing: border-box;
  min-height: 100%;
  padding: 3em 0;
  background-color: currentColor;
}

.theme-info {
  width: 80%;
  color: #fff;
}
.theme-info .graph img {
  width: 100%;
}

.theme-info .text {
  margin-top: 3em;
  text-align: center;
}
.theme-info .text .title {
  margin-bottom: 1em;
  font-size: 1.6em;
}
.theme-info .text .desc {
  font-size: 1.1em;
}

.theme-operation {
  display: grid;
  justify-content: center;
  row-gap: 2em;
  margin-top: 3em;
}
.theme-operation .icon-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 38vw;
  color: #fff;
}
.theme-operation .icon-btn > .icon-btn-svg {
  display: block;
  width: 80%;
  height: 38vw;
  transition: width 0.3s;
}
.theme-operation .icon-btn:not(.disabled) > .icon-btn-svg:hover {
  width: 90%;
}
.theme-operation .icon-btn > .icon-btn-svg svg {
  fill: #fff;
}
.theme-operation .icon-btn.disabled > .icon-btn-svg svg,
.theme-operation .icon-btn.active > .icon-btn-svg svg {
  fill: rgba(255, 255, 255, 0.6);
}

.theme-operation .icon-btn > p {
  margin: 0.2em 0;
  font-size: 1.2em;
  text-align: center;
}
.theme-operation .icon-btn.disabled > p {
  color: rgba(255, 255, 255, 0.6);
}

/** Landscape mobile */
@media only screen and (orientation: landscape) and (max-height: 600px) {
  .detail-box {
    padding: 2em 0;
  }

  .theme-info {
    display: grid;
    grid-template-columns: 45% 45%;
    justify-content: space-between;
    align-items: center;

    width: 90%;
  }
  .theme-info .text {
    margin: 0;
    text-align: left;
    order: 1;
  }
  .theme-info .graph {
    order: 2;
  }

  .theme-operation {
    display: grid;
    grid-template-columns: repeat(auto-fill, 26%);
    justify-content: space-between;
    align-items: flex-start;

    margin-top: 2em;
    width: 90%;
  }
  .theme-operation .icon-btn {
    width: 17vw;
  }
  .theme-operation .icon-btn > .icon-btn-svg {
    height: 17vw;
  }
  .theme-operation .icon-btn > p {
    font-size: 1.1em;
  }
}

/** Larger devices */
@media only screen and (min-width: 601px) and (min-height: 601px) {
  .detail-box {
    padding: 0;
  }

  .theme-info {
    display: grid;
    grid-template-columns: 45% 45%;
    justify-content: space-between;
    align-items: center;

    width: min(90%, 60em);
  }
  .theme-info .text {
    margin: 0;
    font-size: 1.1em;
    text-align: left;
    order: 1;
  }
  .theme-info .graph {
    order: 2;
  }

  .theme-operation {
    display: grid;
    grid-template-columns: repeat(auto-fill, 26%);
    justify-content: space-between;
    align-items: start;

    margin-top: 2em;
    width: min(90%, 60em);
  }
  .theme-operation .icon-btn {
    width: 11em;
  }
  .theme-operation .icon-btn > .icon-btn-svg {
    height: 11em;
  }
}
</style>
